import { ApiSet, IndexApiSet, useIndexApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { GroupByResponse, PagingResponse } from 'entities'
import { CouponCode, CouponCodeGroupBySearchForm, CouponCodeSearchForm } from 'entities/coupon_code'

type CouponCodesResponse = PagingResponse & {
    results: CouponCode[]
}

export function useFetchCouponCodesApi(searchForm?: Form<CouponCodeSearchForm>): IndexApiSet<CouponCodesResponse> & { execute: () => void } {
    const apiPath = 'coupon_codes/'
    const api = useIndexApi<CouponCodesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: searchForm?.object?.page || 1, perPage: searchForm?.object?.perPage || 50 },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm?.object })
    }

    useEffectSkipFirst(() => {
        searchForm?.update((f) => {
            if (api.pageSet.page) f.page = api.pageSet.page
            if (api.pageSet.perPage) f.perPage = api.pageSet.perPage
        })
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}

export function useFetchCouponCodeGroupByApi(searchForm?: Form<CouponCodeGroupBySearchForm>): ApiSet<GroupByResponse> & { execute: () => void } {
    const apiPath = 'coupon_codes/group_by/'
    const api = useShowApi<GroupByResponse>(new CraifHttpClient(), {
        initialResponse: { groups: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, searchForm?.object)
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}
